import { Theme } from '@mui/material';

export default function themeSpacingAsRem(
  spacing: number,
  theme: Theme
): string {
  return theme.typography.pxToRem(theme.spacingScalingFactor * spacing);
}
